export default __webpack_public_path__ + "static/media/guy-coffee.a3d0bf7c.png";